<template>
  <v-menu
    ref="timeMenu"
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    :return-value.sync="timeChanged"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :value="value"
        :label="label || $t('common.time.time')"
        :hint="hint"
        :persistent-hint="persistentHint"
        :prepend-icon="icon || 'mdi-clock-outline'"
        readonly
        v-on="on"
        :rules="rules"
      ></v-text-field>
    </template>
    <v-time-picker
      v-if="menu"
      :value="value"
      :format="format || 'ampm'"
      @input="timeChanged($event)"
    >
      <div class="flex-grow-1"></div>
      <v-btn v-if="deletable && value != null" color="primary" text @click="cancel;">{{
        $t("common.cancel")
      }}</v-btn>
      <v-btn color="primary" @click="menu = false">{{ $t("common.done") }}</v-btn>
    </v-time-picker>
  </v-menu>
</template>

<script>
export default {
  props: ["value", "rules", "icon", "format", "label", "hint", "persistentHint", "deletable"],
  data() {
    return {
      menu: false,
    };
  },
  methods: {
    cancel() {
      this.menu = false;
      this.$emit("input", null);
    },
    timeChanged(time) {
      this.$emit("input", time);
    },
  },
};
</script>
